import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useOrderStore, useOrderShowApi } from '@pages/orders'

import { defineNuxtRouteMiddleware } from '#app'

/** `/orders/{id}` — a different order never shows the previous one while it loads. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const orderId = to.params.id

  if (typeof orderId !== 'string' || !orderId) return

  const orderStore = useOrderStore()

  if (orderStore.getOrder?.id !== Number(orderId)) {
    orderStore.setOrder(null)
    orderStore.setChangelogPayment(null)
  }

  void useOrderShowApi(orderId)
})
